import React from 'react';

import { Container as PromotionProgressBar } from '../PromotionProgressBar';

import { useCartDrawerPromoProgressBar } from './useCartDrawerProgressBar';

const PROMO_TYPE = 'gwp';

export function OldCartDrawerPromoProgressBarRenderer() {
  const { shouldShowProgressBar, total, threshold } =
    useCartDrawerPromoProgressBar();
  if (!shouldShowProgressBar) {
    return null;
  }
  return (
    <PromotionProgressBar
      shouldShowProgressBar
      isGoalReached={total >= threshold}
      total={total}
      promoThreshold={threshold}
      promoType={PROMO_TYPE}
      shouldAnimateOnThreshold
    />
  );
}
